import * as React from 'react';
import ImagesSlider from './ImagesSlider/ImagesSlider';
import Button from '../../Button/Button';
import Money from '../../Money';
import { useTheme } from '../../theme';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { NASProductCategory } from '@websky/graphql';
const EveryPortCard = props => {
    const { t } = useTranslation('ServiceAggregation');
    const theme = useTheme('EveryPortCard').EveryPortCard;
    return (React.createElement("div", { className: theme.container },
        !!props.images.length && (React.createElement("div", { className: theme.images },
            React.createElement(ImagesSlider, { images: props.images }))),
        !props.images.length && (React.createElement("div", { className: cn(theme.images, theme.placeholder, {
                [theme.placeholder_lounge]: props.category === NASProductCategory.lounge,
                [theme.placeholder_vip]: props.category === NASProductCategory.vip,
                [theme.placeholder_meet]: props.category === NASProductCategory.meet_and_greet,
                [theme.placeholder_fasttrack]: props.category === NASProductCategory.fast_track
            }) })),
        React.createElement("div", { className: theme.content },
            React.createElement("div", { className: theme.header }, props.name),
            React.createElement("div", { className: theme.location },
                !!props.terminalName && (React.createElement("div", null,
                    t('Terminal'),
                    " \u2014 ",
                    props.terminalName)),
                React.createElement("div", null, props.location)),
            (!!props.description || !!props.options.length) && (React.createElement("div", { className: theme.description },
                props.description && (React.createElement("div", { className: theme.description__inner, dangerouslySetInnerHTML: {
                        __html: props.description
                    } })),
                !!props.options.length && (React.createElement("ul", { className: theme.options }, props.options.map((option, key) => {
                    return React.createElement("li", { key: key }, option);
                }))))),
            props.onSelect && (React.createElement("div", { className: theme.buttons },
                React.createElement("div", { className: theme.price__wrapper },
                    React.createElement(Button, { onClick: props.onSelect, className: cn(theme.button, {
                            [theme.button_selected]: props.isSelected,
                            [theme.button_priceFrom]: !props.isSelected
                        }) }, props.isSelected ? (t('Change')) : (React.createElement(React.Fragment, null,
                        t('from'),
                        "\u00A0",
                        React.createElement(Money, { money: props.price, moneyClassName: theme.price }))))))))));
};
export default EveryPortCard;
